import React from 'react';
import { MUITableColumn } from 'components/shared/MUITable';
import { Button, Stack, Typography } from '@mui/material';
import { InventoryItemEntity } from './InventoryTable';
import { formatMoney } from '../../utils';

export function createTableColumns({ useHistory }: { useHistory: any }): MUITableColumn<InventoryItemEntity>[] {
  return [
    {
      header: 'Equipment',
      renderKey: 'equipmentDescription',
      sortKey: 'make',
      renderCell: ({ year, make, model, description, vin, stockNumber }) => (
        <Stack
          sx={{
            alignItems: 'left',
            borderRadius: '0.5rem',
          }}
        >
          <Typography>{`${year} ${make} ${model}`}</Typography>
          <Typography variant="body2" color="text.secondary">
            #{stockNumber} | VIN: {vin}
          </Typography>
        </Stack>
      ),
    },
    {
      header: 'Condition',
      renderKey: 'condition',
      sortKey: 'condition',
    },
    {
      header: 'Mileage',
      renderKey: 'mileage',
      sortKey: 'mileage',
      renderCell: ({ mileage }) => <>{mileage || mileage === 0 ? mileage.toLocaleString() : '-'}</>,
    },
    {
      header: 'List Price',
      renderKey: 'retailPrice',
      sortKey: 'retail_price',
      renderCell: ({ retailPrice }) => <>${formatMoney(retailPrice, 0)}</>,
    },
    {
      header: 'Status',
      renderKey: 'status',
      sortKey: 'status',
    },
    {
      header: 'Actions',
      renderKey: 'equipmentId',
      renderCell: ({ equipmentId }) => (
        <div>
          <Button
            variant="outlined"
            onClick={e => {
              e.stopPropagation();
              // handleRedirectToEditEquipmentPage(equipmentId!);
              useHistory.push(`/equipment/${equipmentId}`);
            }}
          >
            Edit
          </Button>
        </div>
      ),
    },
  ];
}
